import { render } from "./PendenciaLista.vue?vue&type=template&id=1b3a0f2d"
import script from "./PendenciaLista.vue?vue&type=script&lang=js"
export * from "./PendenciaLista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__